import { useMutation } from '@tanstack/react-query';
import { message } from 'antd';
import { useNavigate } from 'react-router-dom';
import { api } from '../../@common';

interface ChangePasswordParams {
  token: string;
  newPassword: string;
}

export const useChangePassword = () => {
  const navigate = useNavigate();

  const changePassword = useMutation({
    mutationFn: (data: ChangePasswordParams) =>
      api
        .post('/auth/reset-password', data)
        .then((res) => res.data)
        .catch((error) => {
          message.error('Failed to reset password');
          throw error;
        }),
    mutationKey: ['auth', 'resetPassword'],
    onSuccess: () => {
      message.success('Password updated successfully');
      navigate('/login');
    },
  });

  return {
    changePassword,
    isLoading: changePassword.isPending,
  };
};
